import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base: IconProps = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function IconChevronRight(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

export function IconChevronLeft(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m15 6-6 6 6 6" />
    </svg>
  );
}

export function IconBell(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M6 8a6 6 0 1 1 12 0c0 7 3 8 3 8H3s3-1 3-8" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </svg>
  );
}

export function IconSignature(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 17c2-1 4-7 6-7s2 6 4 6 2-9 4-9 1 5 4 5" />
      <path d="M3 21h18" />
    </svg>
  );
}

export function IconWallet(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 7h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
      <path d="M3 7V6a2 2 0 0 1 2-2h11" />
      <circle cx="16" cy="13" r="1.2" />
    </svg>
  );
}

export function IconDocument(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
    </svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m5 12 5 5L20 7" />
    </svg>
  );
}

export function IconCalendar(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </svg>
  );
}

export function IconTooth(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M7 3c-2 0-3.5 1.5-3.5 4 0 2 1 3.5 1.2 5.5.3 2.4.4 4.3 1 6 .4 1.2 1.3 2.5 2.3 2.5 1.5 0 1.6-3 2-5 .2-1 .8-1.5 2-1.5s1.8.5 2 1.5c.4 2 .5 5 2 5 1 0 1.9-1.3 2.3-2.5.6-1.7.7-3.6 1-6 .2-2 1.2-3.5 1.2-5.5 0-2.5-1.5-4-3.5-4-1.5 0-2.5.7-3.5 1.3-.7.4-1 .5-1.5.5s-.8-.1-1.5-.5C9.5 3.7 8.5 3 7 3z" />
    </svg>
  );
}

export function IconHouse(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 11 12 3l9 8" />
      <path d="M5 10v10h14V10" />
    </svg>
  );
}

export function IconMessage(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12z" />
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function IconCamera(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
      <circle cx="12" cy="13" r="3.5" />
    </svg>
  );
}

export function IconCameraFlip(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
      <path d="M9 13a3 3 0 0 1 5.2-2" />
      <path d="M15 13a3 3 0 0 1-5.2 2" />
      <path d="m14 10 1.2 1L16.4 10" />
      <path d="M10 16 8.8 15 7.6 16" />
    </svg>
  );
}

export function IconActivity(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 12h4l3-8 4 16 3-8h4" />
    </svg>
  );
}

export function IconImages(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="5" width="14" height="14" rx="2" />
      <path d="M21 9v10a2 2 0 0 1-2 2H9" />
      <circle cx="8" cy="10" r="1.5" />
      <path d="m4 18 4-4 4 4" />
    </svg>
  );
}

export function IconWarning(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3 2 21h20L12 3z" />
      <path d="M12 10v5M12 18v.5" />
    </svg>
  );
}

export function IconInfo(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7.5v.5" />
    </svg>
  );
}

export function IconClipboard(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="5" width="12" height="16" rx="2" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
    </svg>
  );
}

export function IconGauges(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3a9 9 0 1 1-9 9" />
      <path d="M12 7.5a4.5 4.5 0 1 1-4.5 4.5" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconHeart(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 20s-7-4.5-9-9.5C1.5 6 5 3 7.5 3 9.5 3 11 4 12 5.5 13 4 14.5 3 16.5 3 19 3 22.5 6 21 10.5c-2 5-9 9.5-9 9.5z" />
    </svg>
  );
}

export function IconBack(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M19 12H6m6-6-6 6 6 6" />
    </svg>
  );
}

export function IconFolder(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
    </svg>
  );
}

export function IconPin(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 17v5" />
      <path d="M9 3h6l-1 5 3 3v3H7v-3l3-3-1-5z" />
    </svg>
  );
}

export function IconAligner(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="9" width="7.5" height="6" rx="1.5" />
      <rect x="13.5" y="9" width="7.5" height="6" rx="1.5" />
      <path d="M10.5 12h3" />
    </svg>
  );
}

export function IconUserSilhouette(props: IconProps) {
  return (
    <svg {...base} {...props} fill="currentColor" stroke="none">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8v1H4v-1z" />
    </svg>
  );
}

export function IconToothLogo(props: IconProps) {
  return (
    <svg
      width={props.width ?? 40}
      height={props.height ?? 40}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 9c-3.5 0-5.5 2.4-5.5 6 0 2.8 1.5 4.8 1.8 7.5.3 3.2.4 5.6 1.2 7.8.5 1.4 1.6 2.7 2.8 2.7 1.7 0 1.8-3.6 2.3-6 .3-1.2 1-1.8 2.4-1.8s2.1.6 2.4 1.8c.5 2.4.6 6 2.3 6 1.2 0 2.3-1.3 2.8-2.7.8-2.2.9-4.6 1.2-7.8.3-2.7 1.8-4.7 1.8-7.5 0-3.6-2-6-5.5-6-2 0-3.2 1-4.5 1.8-.9.5-1.3.6-2 .6s-1.1-.1-2-.6C19.2 10 18 9 16 9z"
        fill="#0c8aa6"
      />
      <path
        d="M8 28c2 1 5 4.5 11 4.5s11.5-3.5 14-5 11-5 14 0c2.5 4-5 11-14 11-3 0-5-1-7-2.5-2-1.5-4-3.5-7-3.5s-7 1.5-9 0-3.5-4.5-1-4.5z"
        fill="var(--sf-primary)"
        opacity="0.85"
      />
    </svg>
  );
}

export function IconSearchLarge(props: IconProps) {
  return (
    <svg {...base} strokeWidth={2.2} {...props}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function IconPlus(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function IconBolt(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="m13 2-9 13h7l-1 7 9-13h-7l1-7z" />
    </svg>
  );
}

export function IconClock(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function IconArrowRight(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M5 12h14m-6-6 6 6-6 6" />
    </svg>
  );
}

export function IconFace(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="9" cy="10" r="0.8" fill="currentColor" />
      <circle cx="15" cy="10" r="0.8" fill="currentColor" />
      <path d="M9 15c1 1 2 1.5 3 1.5s2-.5 3-1.5" />
    </svg>
  );
}

export function IconMouth(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <ellipse cx="12" cy="12" rx="8" ry="4" />
      <path d="M6 12c2-1.5 4-1.5 6-1.5s4 0 6 1.5" />
    </svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  );
}

export function IconPhone(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.86 19.86 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export function IconMail(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

export function IconHelp(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 1.5-2.5 2-2.5 4" />
      <circle cx="12" cy="17" r="0.6" fill="currentColor" />
    </svg>
  );
}

export function IconSend(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M3 20.5 21 12 3 3.5 3 10l13 2-13 2z" />
    </svg>
  );
}

export function IconMic(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="9" y="3" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <path d="M12 18v3" />
    </svg>
  );
}

export function IconLigam(props: IconProps) {
  return (
    <svg
      width={props.width ?? 32}
      height={props.height ?? 32}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.993"
        fill="#ff5b11"
        d="M 257.5,0.5 C 258.822,0.330034 259.989,0.663368 261,1.5C 298.193,46.8936 333.193,93.8936 366,142.5C 390.289,179.069 410.955,217.735 428,258.5C 455.221,331.104 441.054,394.271 385.5,448C 336.892,489.082 280.892,505.082 217.5,496C 141.727,480.551 90.2265,436.718 63,364.5C 55.9081,340.989 53.5748,316.989 56,292.5C 60.0384,250.347 70.0384,209.68 86,170.5C 92.6509,154.514 101.318,139.848 112,126.5C 120.715,136.88 129.048,147.547 137,158.5C 140.682,162.349 144.515,166.016 148.5,169.5C 178.917,109.136 215.251,52.8028 257.5,0.5 Z"
      />
      <path
        fill="#ff9758"
        d="M 250.5,81.5 C 287.193,124.06 320.36,169.393 350,217.5C 359.293,233.418 366.959,250.085 373,267.5C 385.584,317.008 372.084,357.842 332.5,390C 294.216,416.939 252.216,424.939 206.5,414C 157.201,398.702 128.701,365.535 121,314.5C 119.131,298.409 120.798,282.742 126,267.5C 133.418,248.663 142.418,230.663 153,213.5C 163,198.833 173,184.167 183,169.5C 205.716,140.29 228.216,110.957 250.5,81.5 Z"
      />
    </svg>
  );
}
